import { CreateUserMarketingAgreementDto } from '@diritto/common/account/dtos/create-user-marketing-agreement.dto';
import { MutateFn } from '@diritto/common/base/mutateFunction';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AccountApi } from 'api/ApiHelper';
import { accountsQueryKey } from 'queries/account/queryKey';

export const useUserMarketingAgreementMutation = (callback: MutateFn) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: accountsQueryKey.marketingAgreement,
    mutationFn: (data: CreateUserMarketingAgreementDto) => AccountApi.setUserMarketingAgreement(data),

    onMutate: callback.onMutate,
    onSuccess: res => {
      queryClient.invalidateQueries({ queryKey: accountsQueryKey.marketingAgreement });
      callback.onSuccess?.(res);
    },
    onError: callback.onError,
  });
};
